function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M53.29 27h-4a2 2 0 110-4h4a2 2 0 110 4zm-7.86-13.3a2 2 0 11-2.83-2.83l2.83-2.82a2 2 0 012.83 2.82zm-2.94 15.61A12 12 0 0133.29 49h-16a16 16 0 114.53-31.34 12 12 0 0120.67 11.65zM5.3 33a12 12 0 0012 12h16A8 8 0 1029 30.3 12 12 0 005.3 33zm26-16a8 8 0 00-5.66 2.34 16.22 16.22 0 015.63 5.86 12.36 12.36 0 012-.21 11.91 11.91 0 015.85 1.53 7.63 7.63 0 00.17-1.52 8 8 0 00-8-8zm0-8a2 2 0 01-2-2V3a2 2 0 014 0v4a2 2 0 01-2.01 2zm-14.15 4.7l-2.83-2.83a2 2 0 012.83-2.82L20 10.87a2 2 0 01-2.83 2.83z"
});

var SvgPartlyCloudyDay = function SvgPartlyCloudyDay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 56.75 50.56",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPartlyCloudyDay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/partly-cloudy-day.64cef89b.svg";
export { ForwardRef as ReactComponent };